import baseURL from "../../utils/API_URL";
import axios from "axios";

var createQueryString = function (params) {
  const query = Object.keys(params)
    .map((key) => {
      const value = params[key];
      if (typeof value === "object" && value !== null) {
        return Object.keys(value)
          .map(
            (nestedKey) =>
              `${encodeURIComponent(key)}[${encodeURIComponent(
                nestedKey
              )}]=${encodeURIComponent(value[nestedKey])}`
          )
          .join("&");
      } else {
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      }
    })
    .join("&");
  return query;
};

async function callMethodFunc(bo, method, body) {
  if (!localStorage.getItem("MTNToken")) return Promise.reject();
  const url = baseURL + "api/method";
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("MTNToken"),
    Accept: "*/*",
    "Content-Type": "application/json",
  };
  const body1 = {
    IsOData: false,
    BO: bo,
    Method: method,
    HttpMethod: method,
    Company: "EPIC06",
    Plant: "MfgSys",
    Data: body,
    BpmData: {
      Context: {},
    },
  };
  try {
    const response = await axios.post(url, body1, { headers });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.resolve({ message: "error", error });
  }
}
async function methodCreateRequest(user) {
  if (!localStorage.getItem("MTNToken")) return Promise.reject();
  const url = baseURL + "api/create-request";
  const body = {
    name: user.name,
    email: user.email,
    phone: user.phone,
    call_phone: user.phone,
    company_name: user.company,
    company_address: user.company_address,
    title: "Maintenance Request",
    equip: user.equipment,
    serial: user.equipment_serial,
    message: user.comment,
  };
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("MTNToken"),
    Accept: "*/*",
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(url, body, { headers });
    return Promise.resolve(response.data.Data.HDCaseNum);
  } catch (error) {
    return Promise.resolve({ message: "error", error });
  }
}

async function methodCreateRequestPreLogin(requestBody) {
  const url = baseURL + "api/create-request";
  const body = {
    is_test: global.isTest,
    Plant: "MfgSys",
    CellPhone: "",
    Phone: "",
    CompanyName: "",
    CompanyAddress: "",
    Title: "",
    ReqStatus: "Pnd",
    RequestDt: requestBody.RequestDt,
    RequiredDate: requestBody.RequestDt,
    Equip: requestBody.EquipID || "1940",
    EquipID: requestBody.EquipID || "1940",
    PKV_Area_c: requestBody.PKV_Area_c,
    Area: requestBody.PKV_Area_c,
    Name: `${requestBody.PKV_EmpReq_c_last || ""} ${
      requestBody.PKV_EmpReq_c_first || ""
    }`,
    PKV_EmpReq_c: `${requestBody.PKV_EmpReq_c_last || ""} ${
      requestBody.PKV_EmpReq_c_first || ""
    }`,
    Priority: requestBody.Priority,
    IssueDesc: requestBody.IssueDesc,
    issue_desc: requestBody.IssueDesc,
    PKV_DirImp_c: requestBody.PKV_DirImp_c,
    DirImp: requestBody.PKV_DirImp_c,
    dir_imp: requestBody.PKV_DirImp_c,
    Email: requestBody.email,
  };
  const headers = {
    Accept: "*/*",
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(url, body, { headers });
    return Promise.resolve(response.data.Data.RequestID);
  } catch (error) {
    return Promise.resolve({ message: "error", error });
  }
}

async function callBAQEquip() {
  let params = {
    offset: 0,
    fetch: 100,
  };
  let queryString = createQueryString(params);
  const url = `${baseURL}api/equip-list?${queryString}`;
  const headers = {
    Accept: "*/*",
    is_test: global.isTest,
    "Content-Type": "application/json",
    withCredentials: true,
    "Access-Control-Allow-Origin": "Content-Type, is_test",
  };
  const response = await axios.get(url, { headers });
  if (response.status == 200) {
    let res = JSON.parse(response.data.DataRaw);
    return Promise.resolve(res);
  } else {
    return Promise.reject({ message: "error", error: "Fail!" });
  }
}

async function callBAQ(baq, param) {
  if (!localStorage.getItem("MTNToken")) return Promise.reject();
  const url = baseURL + "api/call-baq";
  let isMclean = false;
  try {
    let urlString = location.href;
    if (urlString.includes("mclean")) {
      isMclean = true;
    }
  } catch (e) {
    console.log(e);
  }
  const body = {
    CompanyID: isMclean ? "10MCL" : "epic06",
    Company: isMclean ? "10MCL" : "epic06",
    PlantID: "MfgSys",
    Plant: "MfgSys",
    QueryID: baq,
    IsTest: global.isTest,
    Mode: 0,
    UseNewDataFormat: true,
    Take: 0,
    Skip: 0,
    SortBy: null,
    SysRevID: 0,
    Parameters: param,
  };
  const headers = {
    Accept: "*/*",
    Authorization: "Bearer " + localStorage.getItem("MTNToken"),
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(url, body, { headers });
    return Promise.resolve(JSON.parse(response.data.DataRaw));
  } catch (error) {
    return Promise.resolve({ message: "error", error });
  }
}
async function callApiLogin(email, password) {
  let url = "";
  if (email.includes("@")) {
    localStorage.setItem("isSupplierRole", true);
    url = baseURL + "api/login";
  } else {
    localStorage.setItem("isSupplierRole", false);
    url = baseURL + "api/login-epicor";
  }
  const body = {
    username: email,
    password: password,
    is_test: global.isTest,
  };
  const headers = {
    Accept: "*/*",
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(url, body, { headers });
    return Promise.resolve(response.data.token);
  } catch (error) {
    return Promise.resolve({ message: "error", error });
  }
}
async function callApiRegister(newUser) {
  const url = baseURL + "api/create-request";
  const body = {
    name: newUser.userName,
    email: newUser.userEmail,
    phone: newUser.userPhone,
    call_phone: newUser.userPhone,
    company_name: newUser.company ? newUser.company : "epic06",
    company_address: newUser.company_address
      ? newUser.company_address
      : "123 abc xyz",
    equip: newUser.equipment ? newUser.equipment : "123",
    serial: newUser.equipment_serial ? newUser.equipment_serial : "123",
    title: "Register",
    message: newUser.comment ? newUser.comment : "Register",
  };
  const headers = {
    Accept: "*/*",
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(url, body, { headers });
    return Promise.resolve(response.data.Data.HDCaseNum);
  } catch (error) {
    return Promise.resolve({ message: "error", error });
  }
}
async function callApiChangePassword(old, newp, token) {
  const url = baseURL + "api/changepass";
  const body = {
    old_pass: old,
    new_pass: newp,
  };
  const headers = {
    Authorization: "Bearer " + token,
    Accept: "*/*",
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(url, body, { headers });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.resolve({ message: "error", error });
  }
}

export {
  callMethodFunc,
  methodCreateRequest,
  callBAQ,
  callApiLogin,
  callApiRegister,
  callApiChangePassword,
  callBAQEquip,
  methodCreateRequestPreLogin,
};
